import { useContext } from "react";
import Icon from "../../../assets/icons";
import primaryComponents from "../../../components/primaryComponents";
import styles from "./TableCard.module.scss";
import useTableCard from "./useTableCard";
import { ToastContext } from "../../../hooks/context";
import { useDispatch } from "react-redux";
import { truncateString } from "../../../helpers";
import { addTable } from "../../../store/modules/checkoutInfo";

const TableCard = ({
  table,
  setTableCardId = () => {},
  resetView,
  refetchOrderTables,
}) => {
  const dispatch = useDispatch();
  const triggerToast = useContext(ToastContext);
  const { showMenu, popMenuRef, isLoading, setShowMenu, clearTable } =
    useTableCard({
      refetchOrderTables,
    });

  return (
    <div
      className={`${styles.card} ${
        table?.status === "FREE" ? styles.card_green : styles.card_red
      }`}
    >
      <div className={styles.title_diners_conatiner}>
        <div className={styles.title_container}>
          <p className={"failed--text mb-0"} style={{ padding: "2px 10px" }}>
            {truncateString(table?.name, 25)}
          </p>

          <div className={styles.seats_container}>
            <h6 className="white--text mb-0">{table?.seat_capacity} seats</h6>
            <img
              ref={popMenuRef}
              src={Icon.tableMenuIcon}
              className={styles.menu}
              alt="menu"
              onClick={() => setShowMenu(true)}
            />

            <div>
              {/* Menu Pop up */}
              {showMenu && (
                <div className={styles.menu_container}>
                  <p
                    onClick={() => clearTable(table?.id)}
                    className={styles.clear_table}
                  >
                    {isLoading ? "Clearing table?..." : "Clear table"}
                  </p>
                  <p
                    onClick={() => {
                      // setTableCardId(table?.id);
                      // resetView("isTable", false);
                      // resetView("isOpenBillsWidget", true);
                    }}
                    className={styles.view_bills}
                  >
                    View Bills
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className={styles.diners_container}>
          <div className={styles.diner_icon}>
            <img
              src={
                table?.status === "FREE"
                  ? Icon.dinersIconGreen
                  : Icon.dinersIcon
              }
              alt="diners"
            />
          </div>
          <h6 className="purple--text mb-0">{table?.diners} diners</h6>
        </div>
      </div>
      <primaryComponents.Button
        type="button"
        classNames={`btn smallBtn ${
          table?.status === "FREE" ? "btn--outline-yellow" : "btn--outline-red"
        }`}
        onClick={() => {
          dispatch(
            addTable({
              name: table?.name,
              order_table_id: table?.id,
              diners: 1,
            }),
          );
          triggerToast(
            "Table selected. Start adding orders to this table",
            "success",
          );
          resetView();
        }}
      >
        Add new order
      </primaryComponents.Button>
    </div>
  );
};

export default TableCard;
